import { render, staticRenderFns } from "./DataBuildUnmatched.vue?vue&type=template&id=75d1d51a&scoped=true"
import script from "./DataBuildUnmatched.vue?vue&type=script&lang=js"
export * from "./DataBuildUnmatched.vue?vue&type=script&lang=js"
import style0 from "./DataBuildUnmatched.vue?vue&type=style&index=0&id=75d1d51a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d1d51a",
  null
  
)

export default component.exports